import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Container, Dropdown, Button, Modal,   Nav, } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Card from "../../components/Card";
import s5 from "../../assets/images/page-img/s5.jpg";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "../../views/dashboard/styles.css";
import { getToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  Tabs,
  Tab,
  Box,
  // Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText
} from "@mui/material";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";

import DeviceDescription from "./DeviceDescription";
import { CircularProgress, Pagination } from "@mui/material";
import moment from "moment";
import Sponsored from "../dashboard/Sponsored";
import InfiniteScroll from "react-infinite-scroll-component";
import "./Style.css";
import { LuShoppingBag } from "react-icons/lu";
import { IoMdSearch, IoMdArrowForward } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { SlHandbag } from "react-icons/sl";
import { PiStorefront } from "react-icons/pi";
import { MdQrCode2 } from "react-icons/md";
import { MdOutlineLocalOffer } from "react-icons/md";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { ImSad2, ImSad } from "react-icons/im";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdOutlineModeEdit } from "react-icons/md";
import { HiOutlineEmojiHappy } from "react-icons/hi";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import "../dashboard/Spinner/Spinner.css";
import ExampleComponent from "./ExampleComponent";
import { FaDownload } from 'react-icons/fa';
import { Switch } from '@mui/material';
import FileViewer from './FileViewer';
import { useProjectName } from "../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import PaymentCheckoutLost from "../../components/Payment/PaymentCheckoutLost";
import TopupCheckoutLost from "../../components/Payment/TopupCheckoutLost";
import { MdOutlineFileDownload } from "react-icons/md";
import PaymentCheckoutLostSwitch from "../../components/Payment/PaymentCheckoutLostSwitch";
import { useUser } from "../../Context/UserContext";

const LostDeviceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
const projectName = useProjectName();
const { t, i18n } = useTranslation();
  const { userData } = useUser();
const [activeTab, setActiveTab] = useState("Start New");

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const handleFound = () => {
    navigate(`/lostitem`);
  }
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [deviceCode, setDeviceCode] = useState(null);
  const [itemName, setItemName] = useState(null);
  const [itemDescription, setItemDescription] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [devices, setDevices] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [foundID, setFoundID] = useState("");
  const [qrcUID, setQrcUID] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setFoundID(item?.userDeviceId?._id)
    setShow(true);
  }
  const handleClose1 = () => {
    setShowUserList(false);
    setShow1(false)};
  const handleShow1 = (item) => {
    setFoundID(item?.userDeviceId?._id)
    setQrcUID(item?.qrc_UID)
    setShow1(true);
  }
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [table, setTable] = useState(false);
  const [existQrCode, setExistQrCode] = useState(null);
  const [existQrDetails, setExistQrDetails] = useState(null);
  const [gadgetData, setGadgetData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [qrcData, setQrcData] = useState({
    qrc_UID: '',
    deviceCode: '',
    itemName: '',
    itemDescription: '',
    gadgetCategory: '',
    devicePhotos: [],
  });
  const [selectedFiles, setSelectedFiles] = useState({
    video: null,
    document: null,
    audio: null,
  });
  const [previews, setPreviews] = useState({
    video: null,
    document: null,
    audio: null,
  });
  const [webPageLinkField, setWebPageLinkField] = useState(null);
  const [allQRCData, setAllQRCData] = useState([]);
  const [createQRCData, setCreateQRCData] = useState(null);
  const [userDataCreateQrc, setUserDataCreateQrc] = useState(null);
  const [formData, setFormData] = useState({
    lostStatus: true,
    rewardAmount: "",
    note: "",
    isPublic:false,
    communicateWithFeedbackForm: false,
    typeContactInfo: false,
    includeDiridoProfile: false,
    lostLocationDescription: "",
    isRewardOffered: false,
    paidByEscrow: false,
    paidByUser: false,
    displayEmail: "",
  });
  const [available, setAvailable] = useState("");
  const [allData, setAllData] = useState([]);
const handleAllTerms = async() => {
  try {
      const token = getToken();
    const response = await axios.get(`${process.env.REACT_APP_URL}/api/terms-and-condition/content`, {
      headers: {
        "Authorization": `Bearer ${token}`
              }
    });
    const criticalDTerms = response.data.data.find(item => item.platform === "lost-and-found");
    if(criticalDTerms){
      setAllData(criticalDTerms);
    }
  } catch (error) {
    console.error("Failed Fetching ", error);
  }
}

  const topupAvailable = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/plan/user/purchesed-plan?platform=lost-and-found`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAvailable(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  

  const handleToggleChange = (event) => {
    const isPublic = event.target.checked;
    setFormData(prevData => ({
      ...prevData,
      isPublic,
      communicateWithFeedbackForm: isPublic,
      typeContactInfo: isPublic,
      includeDiridoProfile: isPublic,
    }));
  };

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  setFormData((prevData) => {
    if (name === "paidByEscrow") {
      return {
        ...prevData,
        paidByEscrow: checked,
        paidByUser: false,
      };
    } else if (name === "paidByUser") {
      return {
        ...prevData,
        paidByEscrow: false,
        paidByUser: checked,
      };
    } else if (name === "isPublic") {
      const isPublic = checked;
      return {
        ...prevData,
        isPublic,
        communicateWithFeedbackForm: isPublic,
        typeContactInfo: isPublic,
        includeDiridoProfile: isPublic,
      };
    } else if (name === "rewardAmount") {
      const isRewardOffered = parseFloat(value) > 0; // Check if rewardAmount is more than 0
      return {
        ...prevData,
        rewardAmount: value,
        isRewardOffered,
      };
    }

    return {
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    };
  });
};

  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      phoneNumbers: [value],
    }));
  };

  const [checkboxes, setCheckboxes] = useState({
    termsAccepted: true,
    // authorizeEscrow: true,
    // dischargeLiability: true,
    // diridoJudgment: true,
  });

  // Handle checkbox changes
  const handleCheckboxChangeLost2 = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  // Check if all checkboxes are checked
  const allChecked = Object.values(checkboxes).every((isChecked) => isChecked);

  const handleAcceptTermsCondition = async () => {
    try {
      setLoading(true); 

        const token = getToken();
        const response = await axios.put(
            `${process.env.REACT_APP_URL}/api/terms-and-condition/lost-and-found`,
            {
              lostAndFound: {
                agreeToLostAndFoundTermsAndConition: true,
              }
            }, {
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        }
        )
          setLost2(false);
          setLost3(true);
            } catch (error) {
              toast.error(error?.response?.data?.message || "Failed accepting Terms and condition")
        console.log("Failed Fetching T&C", error);
    } finally{
      setLoading(false); 

    }
  }

  const handleLost3 = () => {
    const allChecked = Object.values(checkboxes).every((isChecked) => isChecked);
  
    if (allChecked) {
      handleAcceptTermsCondition(); 
      // setLost2(false);
      // setLost3(true);
      
    } else {
      toast.error("Please check terms and conditons to proceed.");
    }
  };

    const defaultCurrency = "USD"; 
    const defaultSymbol = "$";
      const [selectedCurrency, setSelectedCurrency] = useState(
          localStorage.getItem("selectedCurrency") || defaultCurrency
      );
      const [currencySymbol, setCurrencySymbol] = useState(
          localStorage.getItem("currencySymbol") || defaultSymbol
      );
      const [showUserList, setShowUserList] = useState(false);
      const [users, setUsers] = useState([]);
      const [selectedUser, setSelectedUser] = useState(null);
      const fetchUsers = async () => {
        try {
          const token = getToken();
          setLoading(true);

          const response = await axios.get(`${process.env.REACT_APP_URL}/api/device/finders/${qrcUID}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.data.status) {
            setUsers(response.data.data.finderList);
            setShowUserList(true);
          } else {
            console.error('Error fetching user list:', response.data.message);
          }
        } catch (error) {
          console.error('Error fetching users:', error);
        } finally{
          setLoading(false);

        }
      };
    
      const handleRefund = async () => {
        try {
          const token = getToken();
          setLoading(true);

          const response = await axios.put(
            `${process.env.REACT_APP_URL}/api/device/update-finder/${qrcUID}`,
            {
              status: 'withdraw',
              finderId: null,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          );
            toast.success(response?.data?.message || 'Refund processed successfully!');
            handleSubmitFound();
        } catch (error) {
          toast.error(error?.response?.data?.message || "Error processing refund")
          console.error('Error processing refund:', error);
        } finally{
          setLoading(false);
        }
      };
    
      const updateFinder = async () => {
        try {
          if (!selectedUser) {
            alert('Please select a user first!');
            return;
          }
              const token = getToken();
setLoading(true)
          const response = await axios.put(
            `${process.env.REACT_APP_URL}/api/device/update-finder/${qrcUID}`,
            {
              status: 'found',
              finderId: selectedUser.finderId._id,
            },
            {
              headers: {
          Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
              },
            }
          );
          toast.success(response?.data?.message || 'Finder updated successfully!');
          setSelectedUser("");
            handleSubmitFound();
    
        } catch (error) {
          toast.error(error?.response?.data?.message || "Error processing finder")
          console.error('Error updating finder:', error);
        } finally{
          setLoading(false)
        }
      };
    
  const handleSubmitLost = async () => {
    const token = getToken();
  
    try {
      // if (formData.paidByEscrow && (!formData.rewardAmount || formData.rewardAmount <= 0)) {
      //   toast.error("Reward amount must be greater than 0 when paid by escrow.");
      //   return; // Exit the function
      // }
      if (!(formData.paidByEscrow || formData.paidByUser)) {
        toast.error("Please select either 'Paid by Escrow' or 'Paid by User'.");
        return;
      }
      
      if (!formData.rewardAmount || formData.rewardAmount <= 0) {
        toast.error("Reward amount is required and must be greater than 0.");
        return;
      }
      setLoading(true); 

      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/device/lost-status/${lostdevieID}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleGetQrc();
      setLostDeviceID("");
      setIsFormVisible(false);  
      if (formData.paidByEscrow) {
        const lostEventId = response.data.data.lostEventId;
        const paymentResult = initiatePayment(lostEventId);
        await paymentResult;
      }
  
      setLost2(false);
      setLost3(false);
      setLost1(true);
    } catch (error) {
      console.error("Error updating lost item status:", error);
      toast.error(error?.response?.data.message || "Failed marking as lost");
    } finally{
      setLoading(false); 

    }
  };

  const initiatePayment = async (id) => {
    if (!id) {
      toast.error("Lost Event ID is required to initiate payment.");
      return; 
    }
    try {
      const payload = {
        amount: formData?.rewardAmount,
        currency: selectedCurrency,
        paymentFor: "reward",
        lostEventId: id
      };
      setLoading(true)
      const token = getToken();
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/payment/initiate-payment`, payload, {
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      const paymentUrl = response.data.url;
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        toast.error(response?.data?.message || 'Failed to retrieve payment URL.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      toast.error(error?.response?.data?.message || 'Failed to initiate payment. Please try again.');
    } finally{
      setLoading(false)
    }
  };

  const handleSubmitFound = async () => {
    const token = getToken();
  
    try {
      setLoading(true);
  
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/device/lost-status/${foundID}`,
        { lostStatus: false },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleGetQrc();
      setFoundID("");
      handleClose();
      handleClose1();
    } catch (error) {
      toast.error(error?.response?.data.message || "Failed marking as found");
      console.error("Error:", error);
    } finally {
      setLoading(false); 
    }
  };
  




  const handleExpand = () => {
    setExpanded(!expanded)
  };


  const handleTable = () => {
    setTable(!table);
  }
  const [openTables, setOpenTables] = useState({});

  const handleTableLogs = (qrc_UID) => {
    setOpenTables((prevTables) => ({
      ...prevTables,
      [qrc_UID]: !prevTables[qrc_UID], 
    }));
  };
  
  const [activeIndex, setActiveIndex] = useState(null);
  const [scanLogs, setScanLogs] = useState({});

  const handleLogTable = async (index, qrcUID) => {
    if (activeIndex === index) {
      setActiveIndex(null);
      return;
    }

    setActiveIndex(index);

    const token = getToken();


   
    try {
      setLoading(true)
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/device/scan-logs/${qrcUID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setScanLogs((prevLogs) => ({
        ...prevLogs,
        [qrcUID]: response.data.data.scanLogs,
      })); 
       } catch (error) {
      console.error("Error fetching scan logs:", error);
    } finally{
      setLoading(false)
    }
  };

  const [lostdevieID, setLostDeviceID] = useState("");
  const handleToggleForm = (id) => {
    const uid = id?.qrc_UID
    setLostDeviceID(id?.userDeviceId?._id);
    setTable(false);
    setLost2(false);
    setLost3(false);
    setLost1(true);
    setIsFormVisible((prev) => (prev === uid ? null : uid));
    setOpenForms(false);
    setFormData({
      lostStatus: true,
    rewardAmount: "",
    note: "",
    isPublic:false,
    communicateWithFeedbackForm: false,
    typeContactInfo: false,
    includeDiridoProfile: false,
    lostLocationDescription: "",
    isRewardOffered: false,
    paidByEscrow: false,
    paidByUser: false,
    displayEmail: "",
    })
  };
  
  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!itemName) {
      toast.error("Device Name required");
      return;
    }
    if (!itemDescription) {
      toast.error("Device Description required");
      return;
    }
    if (uploadedFiles?.length === 0) {
      toast.error("Please upload images!");
      return;
    }
    try {
      const dataToSent = {
        deviceCode: deviceCode,
        itemName: itemName,
        itemDescription: itemDescription,
        devicePhotos: uploadedFiles,
      };
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/device/add`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleGetAllDevices();
      toast.success("Device added successfully!");
      setShow(null);
      setDeviceCode("");
      setItemName("");
      setItemDescription("");
      setUploadedFiles([]);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      // setShow(false);
    }
  };

  const handleGetAllDevices = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/device/all?page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDevices(response?.data?.data?.deviceList);
      setHasMore(response?.data?.data?.deviceList?.length > 0);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };


  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );

      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  const [expandedRow, setExpandedRow] = useState(null);
  const [home, setHome] = useState(true);
  const [firstPage, setFirstpage] = useState(false);
  const [secondPage, setSecondPage] = useState(false);
  const [thirdPage, setThirdPage] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [selectedHeader, setSelectedHeader] = useState("Start New");
  const [showRegisterDetail, setShowRegisterDetail] = useState(false);
  const [rewardChecked, setRewardChecked] = useState(false);
  const [rewardAmount, setRewardAmount] = useState('');
  const [paymentOption, setPaymentOption] = useState('');
  const handleRewardCheckbox = (e) => {
    setRewardChecked(e.target.checked);
    if (!e.target.checked) {
      setRewardAmount('');
      setPaymentOption('');
    }
  };

  const handleRewardAmountChange = (e) => {
    setRewardAmount(e.target.value);
    if (e.target.value === '') {
      setPaymentOption('');
    }
  };

  const handlePaymentOptionChange = (e) => {
    setPaymentOption(e.target.value);
  };
  const handleHeaderClick = (header) => {
    setSelectedHeader(header);
    if (header === "My Dirido QRC") {
      setHome(false);
      setTable(false);
      setFirstpage(false);
      setSecondPage(false);
      setThirdPage(false);
      setTrack(false);
      setQrcList(true);
    } else if (header === "Track") {
      setHome(false);
      setFirstpage(false);
      setTable(false);
      setSecondPage(false);
      setThirdPage(false);
      setQrcList(false);
      setTrack(true);
    } else {
      setHome(true);
      setTrack(false);
      setQrcList(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab === "2") {
      handleHeaderClick("My Dirido QRC");
    } else if (tab === "3") {
      handleHeaderClick("Track");
    }
  }, [location]);
  

  const getBackgroundColor = (header) => {
    return selectedHeader === header ? "#50B5FF" : "transparent";
  };
  const getTextColor = (header) => {
    return selectedHeader === header ? "#FFF" : "#777D74";
  };


  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const downloadQR = () => {
    const qrUrl = existQrDetails?.qrcCodeUrl || createQRCData?.qrCodeUrl;
    const itemName = qrcData.itemName || "QR_Code";  // Fallback to "QR_Code" if itemName is not available
    const imageName = existQrDetails?.qrcCode ? existQrDetails?.qrcCode : createQRCData?.qrc_UID;  // Use qrcCode or qrc_UID as the image name
    
    if (qrUrl) {
        const image = new Image();
        image.src = qrUrl;

        image.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // Set canvas size (e.g., same size as image)
            canvas.width = image.width;
            canvas.height = image.height + 40; // Add space for text below the image

            // Set the background color to white
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);  // Fill the entire canvas with white

            // Draw the image on the canvas
            ctx.drawImage(image, 0, 0);

            // Set font and position for item name below the image
            ctx.font = "16px Arial";  // Adjust font size as needed
            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.fillText(itemName, canvas.width / 2, image.height + 30); // 30px below the image

            // Convert canvas to data URL and create download link
            const dataUrl = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `${imageName}_QR_Code.png`;  // Download filename will include imageName
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
    } else {
        console.error("QR code URL not found.");
    }
    setShowMenu(false);
};





  const handleFirst = () => {
    handleGetExistingQr();
  };
  const handleFirstQRC = () => {
    setHome(false);
    setFirstpage(true);
    setShowRegisterDetail(true)
  };
  const toPageSecond = () => {
    setFirstpage(false);
    setSecondPage(true);
  };
  const toPageThird = () => {
    setSecondPage(false);
    setThirdPage(true);
  };
  const toPageList = () => {
    setThirdPage(false);
    setQrcList(true);
    handleHeaderClick("My Dirido QRC")
  };

  const backHome = () => {
    setFirstpage(false);
    setHome(true);
  };
  const backFirst = () => {
    setSecondPage(false);
    setFirstpage(true);
  };
  const backSecond = () => {
    setThirdPage(false);
    setSecondPage(true);
  };

  const [include, setInclude] = useState(false);
  const [diridoProfile, setDiridoProfile] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [webpageLink, setWebpageLink] = useState(false);
  const [balance, setBalance] = useState(5);
  const [promotionCode, setPromotionCode] = useState('');
  const [qrcList, setQrcList] = useState(false);
  const [track, setTrack] = useState(false);
  const [checkedOptions, setCheckedOptions] = useState({
    first: true,
    second: false,
    third: false,
  });


  const handleCheckboxChange = (option) => {
    const newCheckedOptions = {
      ...checkedOptions,
      [option]: !checkedOptions[option],
    };

    let newBalance = 5;

    if (newCheckedOptions.second) newBalance += 10;
    if (newCheckedOptions.third) newBalance += 10;

    setCheckedOptions(newCheckedOptions);
    setBalance(newBalance);
  };

  const handlePromotionCodeChange = (event) => {
    setPromotionCode(event.target.value);
  };
  const [mark, setMark] = useState(false);
  const handleLost = () => {
    setIsFormVisible(false);
    setMark(true);
  }
  const data = [
    { QRID: "ADC13HJHB213", title: "My Travel Luggage" },
  ];

  const clearData = () => {
    setQrcData({
      qrc_UID: '',
      deviceCode: '',
      itemName: '',
      itemDescription: '',
      gadgetCategory: '',
      devicePhotos: [],
    });
    setInclude(false);
    setDiridoProfile(false);
    setShowContact(false);
    setWebpageLink(false);
    setWebPageLinkField("");
    setOpenForms("");
    setSelectedQR("");
    setAllUploadedFiles();
  }
  const [openForms, setOpenForms] = useState(false);

const [deviceIDPost, setDeviceIDPost] = useState("")
  const handleEdit = (uid) => {
    // Check if the form for the particular uid is open
    if (openForms[uid]) {
      setDeviceIDPost("");

      // If it's open, close it by setting its value to false
      setOpenForms(prevState => ({
        ...prevState,
        [uid]: false
      }));
    } else {
      // If it's closed, perform the handleEdit logic and open it
      clearData();
      setDeviceIDPost(uid)
      handleQRDetail(uid);
      setOpenForms(prevState => ({
        ...prevState,
        [uid]: true
      }));
    }
    setIsFormVisible(false);
  };
  
const [selectedQR, setSelectedQR] = useState("")
  const handleQRDetail = async (uid) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/device/details/${uid}?keyword=deviceData`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSelectedQR(response.data.data.deviceAndQrcContentData);
      const data = response.data.data.deviceAndQrcContentData
      setQrcData({
        qrc_UID: data?.qrc_UID,
        deviceCode: data?.qrcContentId?.userDeviceId?._id,
        itemName: data?.qrcContentId?.userDeviceId?.itemName,
        itemDescription: data?.qrcContentId?.userDeviceId?.itemDescription,
        gadgetCategory: data?.qrcContentId?.userDeviceId?.gadgetCategory,
        devicePhotos: data?.qrcContentId?.userDeviceId?.devicePhotos,
      })
      setAllUploadedFiles(data?.qrcContentId?.userDeviceId?.devicePhotos || []);
      setInclude(!!data?.qrcContentId?.lostAndFoundContent?.includeConfig?.include);
      setDiridoProfile(!!data?.qrcContentId?.lostAndFoundContent?.includeConfig?.includeInfo?.includeDiridoProfile);
      setShowContact(!!data?.qrcContentId?.lostAndFoundContent?.includeConfig?.includeInfo?.includeContactInfo);
      setWebpageLink(!!data?.qrcContentId?.lostAndFoundContent?.includeConfig?.includeInfo?.includeWebPageLink);
      
      setWebPageLinkField(data?.qrcContentId?.lostAndFoundContent?.webPageLink || '');
      // setIsFormOpen(true);
    } catch (error) {
      console.log("Failed", error);
    }
  };


  const [lost1, setLost1] = useState(true)
  const [lost2, setLost2] = useState(false)
  const [lost3, setLost3] = useState(false)

  const handleLost2 = () => {
    if (!formData.lostLocationDescription){
      alert("Location is required before proceeding.");
      return;
    }
    setLost1(false);
    setLost2(true);
  }

  const handleGetExistingQr = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/device/verify/${existQrCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setExistQrDetails(response?.data?.data);
      setQrcData({
        ...qrcData,
        qrc_UID: response?.data?.data?.qrcCode,
        deviceCode: response?.data?.data?.qrcCode,
      });
      toast.success(response?.data?.message)
      setHome(false);
      setFirstpage(true);
      setShowRegisterDetail(false)
      setExistQrCode();
    } catch (error) {
      toast.error(error?.response?.data?.message)
      console.log("Failed", error);
    }
  };

  useEffect(() => {
    {
      existQrCode &&
        handleGetExistingQr();
    }
    handleGetGadget();
  }, []);
  const handleGetGadget = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/values?getFeild=gadgetCategory`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setGadgetData(response?.data?.data?.defaultData?.gadgetCategory)
    } catch (error) {
      toast.error(error?.response?.data?.data?.message)
      console.log("Failed", error);
    }
  };
  const handleQrcDataChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setQrcData({ ...qrcData, [name]: files })
    }
    else {
      setQrcData({ ...qrcData, [name]: value })
    }
  }

  const [pendingFiles, setPendingFiles] = useState([]);
  const [allUploadedFiles, setAllUploadedFiles] = useState([]); 

const handleFileInputChangeEdit = async (event) => {
  setIsLoading(true);

  // Get the newly selected files
  const chosenFiles = Array.from(event.target.files);

  // Filter out files that have already been uploaded
  const newFiles = chosenFiles.filter(file => !pendingFiles.some(pendingFile => pendingFile.name === file.name));

  // Check file sizes and add to pending files
  const validFiles = newFiles.filter(file => file.size <= 2097152);

  if (validFiles.length > 0) {
    // Add valid files to pending files state
    // setPendingFiles(prevFiles => [...prevFiles, ...validFiles]);
    setPendingFiles(prevFiles => [...(prevFiles || []), ...validFiles]);
  }

  try {
    // Use `let` to allow reassignment
    let formData = new FormData();
    validFiles.forEach(file => {
      formData.append("files", file);
    });

    const token = getToken();
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(response?.data?.message);
    const newFileUrls = response?.data?.data || [];

    // Update the state with all uploaded files including new ones
    // setAllUploadedFiles(prevFiles => [...prevFiles, ...newFileUrls]);
    setAllUploadedFiles(prevFiles => [...(prevFiles || []), ...newFileUrls]);

  } catch (error) {
    console.log("Failed uploading file", error);
    toast.error(error?.response?.data?.message);
  } finally {
    // Clear the pending files state after processing
    setPendingFiles([]);
    setIsLoading(false);
  }
};



  const handleFileInputChange = async (event) => {
    setIsLoading(true);
    const chosenFiles = Array.prototype.slice.call(event.target.files);
    const uploaded = [...photos];
    chosenFiles.some((file) => {
      if (file?.size > 2097152) {
        toast.error('Entity is too large!');
        return;
      };
      uploaded.push(file);
    });
    setPhotos(uploaded);
    try {
      const formData = new FormData();
      uploaded.forEach((file) => {
        formData.append("files", file);
      });
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success(response?.data?.message);
      setQrcData({ ...qrcData, ['devicePhotos']: response?.data?.data })
      setUploadedFiles(response?.data?.data);
    } catch (error) {
      console.log("Failed uploaading file", error)
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };
  const splitFileLink = (a) => {
    const x = a.split("/");
    const y = x[x.length - 1];
    const p = y.split("_");
    const q = p[p.length - 1];
    return decodeURIComponent(q);
  };
  const handleAbc = (e, fileType) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFiles({ ...selectedFiles, [fileType]: file });

      // Generate preview based on file type
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews({ ...previews, [fileType]: reader.result });
      };

      if (fileType === 'image' || fileType === 'video' || fileType === 'audio') {
        reader.readAsDataURL(file);
      } else if (fileType === 'document') {
        reader.readAsText(file);  // Text preview for documents
      }
    }
    handleFileChange(e);
  };
  const handleFileChange = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    for (const [key, file] of Object.entries(selectedFiles)) {
      if (file) {
        formData.append(key, file);
      }
    }

    try {
      const token = getToken();
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/file/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  };

  const handlePreviewUpdate = async (e) => {
    e.preventDefault();

    try {

      const dataToSent = {
        // "lostStatus": markLost,
        // "rewardAmount": rewardAmount
      }
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/device/lost-status`,
        dataToSent, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
      );
      toast.success(response?.data?.message);

    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  }
  const [youtube, setYoutube] = useState("")
  const handleDropdown = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/default-setting`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setYoutube(response?.data?.data?.isDefaultSettingsExist?.tutorialLinkForLostAndFound[0]);
      } catch (error) {
        console.error("Failed Fetching dropdown", error);
      }
    };
  

  const handleAddDevice = async (e) => {
    e.preventDefault();
    if (qrcData.itemName === '') {
      toast.error('Device Name is required!');
      return;
    }
    try {
      setLoading(true); 

      const dataToSent = {
        // "alreadyHaveDiridoDevice": "false",
        "qrc_UID": qrcData.qrc_UID,
        "deviceCode": qrcData.deviceCode,
        "itemName": qrcData.itemName,
        "itemDescription": qrcData.itemDescription,
        "gadgetCategory": qrcData.gadgetCategory,
        "devicePhotos": allUploadedFiles,
        // "devicePhotos": qrcData.devicePhotos,
        "includeConfig": {
          "include": include,
          "includeInfo": {
            "includeDiridoProfile": diridoProfile,
            "includeContactInfo": showContact,
            "includeWebPageLink": webpageLink
          }
        },
        "webPageLink": webPageLinkField,
      };

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/device/add`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      toPageThird();
      handleGetQrc();
      setShow(null);
            clearData();
      handleHeaderClick("My Dirido QRC");
      setActiveTab("My Dirido QRC");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false); 
      // setShow(false);
    }
  };
  const handleEditDevicePost = async (e) => {
    e.preventDefault();
    if (qrcData.itemName === '') {
      toast.error('Device Name is required!');
      return;
    }
    try {
      const dataToSent = {
        // "alreadyHaveDiridoDevice": "false",
        "qrc_UID": deviceIDPost,
        "deviceCode": deviceIDPost,
        "itemName": qrcData.itemName,
        "itemDescription": qrcData.itemDescription,
        "gadgetCategory": qrcData.gadgetCategory,
        "devicePhotos": allUploadedFiles,
        // "devicePhotos": qrcData.devicePhotos,
        "includeConfig": {
          "include": include,
          "includeInfo": {
            "includeDiridoProfile": diridoProfile,
            "includeContactInfo": showContact,
            "includeWebPageLink": webpageLink
          }
        },
        "webPageLink": webPageLinkField,
      };

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/device/add`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      clearData();
      setDeviceIDPost("");
      setOpenForms("");      
      handleGetQrc();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      // setShow(false);
    }
  };
  const handleEditDevice = async (e) => {
    e.preventDefault();
    if (qrcData.qrc_UID === '') {
      toast.error('Device is required!');
      return;
    }
    try {
      setLoading(true); 

      const dataToSent = {
        // "alreadyHaveDiridoDevice": "false",
        // "qrc_UID": qrcData.qrc_UID,
        // "deviceCode": qrcData.deviceCode,
        "itemName": qrcData.itemName,
        "itemDescription": qrcData.itemDescription,
        "gadgetCategory": qrcData.gadgetCategory,
        "devicePhotos": allUploadedFiles,
        // "devicePhotos": qrcData.devicePhotos,
        "includeConfig": {
          "include": include,
          "includeInfo": {
            "includeDiridoProfile": diridoProfile,
            "includeContactInfo": showContact,
            "includeWebPageLink": webpageLink
          }
        },
        "webPageLink": webPageLinkField || '',
      };

      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/device/${qrcData.deviceCode}`,
        dataToSent,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      clearData();
      setOpenForms("");
      handleGetQrc();
      // toPageThird();
      // setShow(null);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false); 

      // setShow(false);
    }
  };
  const handleIncludeCheckboxChange = (e) => {
    setInclude(e.target.checked);
    if (!include) {
      setDiridoProfile(null);
      setShowContact(null);
      setWebpageLink(null);
    }
  }
  useEffect(() => {
    if (!include) {
      setQrcData((prevState) => ({
        ...prevState,
        itemDescription: '',
      }));
    }
  }, [include])

  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchUserData = async () => {
    try {
      setLoading(true); 

      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    } finally {
      setLoading(false);
    }
  };
 

  // Handle checkbox change
  const profileData = user;
  // const profileData = existQrDetails?.userData ? existQrDetails?.userData : userDataCreateQrc;
  const handleCheckboxChangee = (e, key) => {
    if (key === 'profile') {
      setDiridoProfile(e.target.checked);
    } else {
      setShowContact(e.target.checked);
    }
    const isChecked = e.target.checked;
    let updatedDescription = qrcData.itemDescription;

    if (key === 'profile') {
      if (isChecked) {
        // Append profile data from a new line
        updatedDescription += `\nName: ${profileData?.firstName + ' ' + profileData?.lastName}`;
      } else {
        // Remove the profile data along with the newline character
        const profileWithNewline = `\nName: ${profileData?.firstName + ' ' + profileData?.lastName}`;
        updatedDescription = updatedDescription.replace(profileWithNewline, '');

        // If profile data is at the beginning, remove it without the leading newline
        if (updatedDescription.startsWith(profileData?.firstName + ' ' + profileData?.lastName)) {
          updatedDescription = updatedDescription.replace(profileData?.firstName + ' ' + profileData?.lastName, '');
        }
      }
    }
    if (key === 'contact') {

      if (isChecked) {
        updatedDescription += `\nMobile: ${profileData?.mobileCode || "N/A"} ${profileData?.mobile || "N/A"}  \nEmail: ${profileData?.email}`; // Append profile data
      } else {
        // Remove the profile data along with the newline character
        const profileWithNewline = `\nMobile: ${profileData?.mobileCode || "N/A"} ${profileData?.mobile || "N/A"}  \nEmail: ${profileData?.email}`;
        updatedDescription = updatedDescription.replace(profileWithNewline, '');

        // If profile data is at the beginning, remove it without the leading newline
        if (updatedDescription.startsWith(`\nMobile: ${profileData?.mobileCode || "N/A"} ${profileData?.mobile || "N/A"}  \nEmail: ${profileData?.email}`)) {
          updatedDescription = updatedDescription.replace(`\nMobile: ${profileData?.mobileCode || "N/A"} ${profileData?.mobile || "N/A"}  \nEmail: ${profileData?.email}`, '');
        }
      }
    }

    // Update the state with the new description
    setQrcData((prevState) => ({
      ...prevState,
      itemDescription: updatedDescription,
    }));
  };
  const handleCreateQrc = async (e) => {
    e.preventDefault();
    const data = {
    }
    try {
      setLoading(true); 

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/lost-and-found/generate`, data, {
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      }
      ); 
      toast.success(response?.data?.message);
      setCreateQRCData(response?.data?.data?.newQrc);
      setQrcData({
        ...qrcData,
        qrc_UID: response?.data?.data?.newQrc?.qrc_UID,
        deviceCode: response?.data?.data?.newQrc?.qrc_UID,
      });
      setUserDataCreateQrc(response?.data?.data?.userData);
      handleFirstQRC();
      handleGetQrc();
      topupAvailable();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally{
      setLoading(false); 

    }
  }
  const handleGetQrc = async () => {
    try {
      setLoading(true); 

      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/all?platform=lost-and-found`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      }
      )
      setAllQRCData(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching qrc", error);
    } finally{
      setLoading(false); 

    }
  }
  

  const handleDownloadQRCPaid = (cardDetails) => {
    const link = document.createElement('a');
    link.href = cardDetails.qrCodeUrl; 
    link.download = 'QRCode.png'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const canvasRef = useRef(null);


  const handleDownloadQRCFree = (cardDetails) => {
  
    if (!cardDetails?.qrCodeUrl) {
      alert("QR code URL is missing.");
      return;
    }
  
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image = new Image();
  
    image.crossOrigin = "anonymous";
    image.src = cardDetails.qrCodeUrl;
  
    image.onload = () => {
      const qrcUID = cardDetails.qrc_UID || "";
      const uidFontSize = 18;
      const linkFontSize = 10;
      const uidLineHeight = 18;
      const linkLineHeight = 14;
      const totalExtraHeight = uidLineHeight + linkLineHeight + 10;
  
      canvas.width = image.width;
      canvas.height = image.height + totalExtraHeight;
  
      // White background
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, canvas.width, canvas.height);
  
      // Draw QR code
      context.drawImage(image, 0, 0);
  
      // Center alignment
      context.textAlign = "center";
  
      // qrc_UID - Bold & larger, less top margin
      context.font = `bold ${uidFontSize}px Arial`;
      context.fillStyle = "#000000";
      context.fillText(qrcUID, canvas.width / 2, image.height + 12);
  
      // www.dirido.com - Slightly lower
      context.font = `${linkFontSize}px Arial`;
      context.fillStyle = "#000000";
      context.fillText("www.dirido.com", canvas.width / 2, image.height + 12 + linkLineHeight);
  
      // Download
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "QRCode.png";
      link.click();
    };
  
    image.onerror = () => {
      alert("Failed to load QR code image.");
    };
  };
  
  
  
  const handleVisitCount = async () => {
    try {
        const token = getToken();
        const response = await axios.post(
            `${process.env.REACT_APP_URL}/api/stats/module`,
            {
                moduleType: "lostAndFound"
            }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
        );
        
    } catch (error) {
        console.error('Failed Visit count', error);
    }

}


useEffect(() => {
  const loadInitialData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchUserData(),
        topupAvailable(),
        handleDropdown(),
        handleGetQrc(),
        handleGetGadget(),
        handleUpcoming(),
        handleAllTerms(),
        handleVisitCount()
      ]);
    } catch (error) {
      console.error("Failed loading initial data:", error);
      toast.error("Failed to load initial data");
    } finally {
      setLoading(false);
    }
  };
  
  loadInitialData();
}, []);

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loading && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
<div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg={8} className="row m-0 p-0" >
              <Col sm={12}>
                <div >
                  <div className="text-primary" style={{ fontWeight: "bold", fontSize: "20px", display: "flex", justifyContent: "center" }}>
                    {t('lost_and_found')}
                  </div>
                  <div className="text-primary" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom:"15px" }}>
                    <div>
                    {youtube && (
                <a className="text-primary" href={youtube} style={{  textDecoration: "none", display: "inline-flex", alignItems: "center" }}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube Icon" style={{ width: "25px", height: "18px", marginInline: "5px" }} />
                    {t('watch_how_it_works')}
                </a>)}
                    </div>
                    <div style={{display:"flex"}} className="d-none d-lg-flex">
                <div >{user?.isEnrolledInLostAndFound ?  <div style={{display:"flex", gap:"10px"}}><TopupCheckoutLost selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/> <PaymentCheckoutLostSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/></div>: <PaymentCheckoutLost selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>}</div>
            </div>
                  </div>
                   <div style={{display:"flex", justifyContent:"right", marginBottom:"10px"}} className="d-flex d-lg-none">
                <div >{user?.isEnrolledInLostAndFound ?  <div style={{display:"flex", gap:"10px"}}><TopupCheckoutLost selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/> <PaymentCheckoutLostSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/></div>: <PaymentCheckoutLost selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>}</div>
            </div>
            {!loading && user && !user?.isEnrolledInLostAndFound && (
  <span
    style={{
      color: "red",
      fontWeight: "600",
      display: "flex",
      justifyContent: "right",
      marginTop: "-10px",
    }}
  >
    {t("purchasePlanBeforeActivity")}
  </span>
)}

                </div> 
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                
<Nav
  variant="pills"
  activeKey={activeTab}
  className="connection-tabs-nav p-0 m-0 round"
>

<Nav.Item as="li">
  <Nav.Link
    eventKey="Start New"
    className="text-center"
    onClick={() => {
      clearData();
      handleHeaderClick("Start New");
      setActiveTab("Start New");
    }}
  >
    {t('start_new')}
  </Nav.Link>
</Nav.Item>

<Nav.Item as="li">
  <Nav.Link style={{whiteSpace:"nowrap"}}
    eventKey="My Dirido QRC"
    className="text-center"
    onClick={() => {
      clearData();
      handleHeaderClick("My Dirido QRC");
      setActiveTab("My Dirido QRC");
    }}
  >
    {t('my')} {projectName} {t('qrc')}
  </Nav.Link>
</Nav.Item>

<Nav.Item as="li">
  <Nav.Link
    eventKey="Track"
    className="text-center"
    onClick={() => {
      handleHeaderClick("Track");
      setActiveTab("Track");
    }}
  >
    {t('track')}
  </Nav.Link>
</Nav.Item>

</Nav>

                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <div className="w-100">
                        <div>
                          {home && (
                            <div>
                              <div className="cont_head">
                                <div
                                  className={`sub_cont ${expandedRow === "first" ? "expanded" : ""
                                    }`}
                                  onClick={() =>
                                    setExpandedRow(
                                      expandedRow === "first" ? null : "first"
                                    )
                                  }
                                >
                                  <LuShoppingBag
                                    size={28}
                                    style={{ paddingRight: "10px" }}
                                  />{" "}
                                  {t('register_my_item')}
                                </div>
                                {expandedRow === "first" && (
                                  <div className="sub_cont1">
                                    <IoMdSearch
                                      size={30}
                                      style={{ paddingRight: "10px" }}
                                    />
                                    <input
                                      placeholder={t('enter_qrc_code')}
                                      className="input_sub"
                                      value={existQrCode}
                                      onChange={(e) => setExistQrCode(e.target.value)}
                                    />
                                    <IoMdArrowForward
                                      size={30}
                                      style={{
                                        paddingLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleFirst}
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="cont_head" >
                                <div
                                  className={`sub_cont ${expandedRow === "second" ? "expanded" : ""
                                    }`}
                                  // onClick={() =>
                                  //   setExpandedRow(
                                  //     expandedRow === "second"
                                  //       ? null
                                  //       : "second"
                                  //   )
                                  // }
                                  onClick={() => navigate("/store-item")}                                  // style={{background:"red"}}
                                >
                                  <SlHandbag
                                    size={28}
                                    style={{ paddingRight: "10px" }}
                                  />{" "}
                                  {t('i_need_a')} {projectName} {t('product')}
                                </div>
                                {expandedRow === "second" && (
                                  <div className="sub_cont1" >
                                    <PiStorefront
                                      size={28}
                                      style={{ paddingRight: "10px" }}
                                    />{" "}
                                   <span >{t('go_to')} {projectName} {('store')}</span> 
                                  </div>
                                )}
                              </div>

                              <div className="cont_head">
                                <div className="sub_cont" onClick={handleCreateQrc}>
                                  <MdQrCode2
                                    size={28}
                                    style={{ paddingRight: "10px" }}
                                  />
                                  <span
                                    style={{
                                      color: "rgb(205,155,0)",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {t('get')} {projectName} {t('free_qrc')}
                                  </span>
                                </div>
                                <div className="sub_cont">
                                  <MdOutlineLocalOffer
                                    size={28}
                                    style={{ paddingRight: "10px" }}
                                  />{" "}
                                  {t('special_offer_and_more')}
                                </div>
                              </div>
                            </div>
                          )}
                          {firstPage && (
                            <div>
                              <div
                                style={{
                                  marginTop: "-10px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <IoIosArrowRoundBack
                                  size={28}
                                  onClick={backHome}
                                  style={{ display: "flex" }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "14px",
                                  }}
                                >
                                  1/3
                                </div>
                              </div>
                              {showRegisterDetail ? (
                                <p style={{ fontSize: "18px", width: "80%", marginInline: "auto", display: "flex", justifyContent: "center" }}>{t('great_you_just_created')} {projectName} {t('qrc_register_details')} </p>
                              ) : (
                                <p style={{ fontSize: "18px", width: "80%", marginInline: "auto", display: "flex", justifyContent: "center" }}>{t('great_your')} {projectName} {t('qrc_ready_to_register')}</p>
                              )}
                              <div className="second_cont">

                                <div style={{ width: "100%", marginInline: "auto", display: "flex"}} >
                                  <div className="second_cont" >
                                    <div
                                      className="sub_second_cont1"
                                      style={{
                                        position: "relative",
                                        justifyContent: "left",
                                        flexDirection: "column",
                                        width: "30%",
                                      }}
                                    >
                                      <div
                                        className="menu_icon"
                                        onClick={toggleMenu}
                                      >
                                        <BiDotsVerticalRounded size={24} />
                                      </div>
                                      {showMenu && (
                                        <div className="menu">
                                          <button onClick={downloadQR}>
                                            {t('download')}
                                          </button>
                                        </div>
                                      )}
                                      <img
                                        style={{ display: "flex" }}
                                        src={existQrDetails?.qrcCodeUrl ? existQrDetails?.qrcCodeUrl : createQRCData?.qrCodeUrl}
                                        className="image_second"
                                        alt="QR"
                                      />

                                      <div
                                        style={{
                                          display: "flex",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {qrcData.itemName ? qrcData.itemName : ""}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {existQrDetails?.qrcCode ? existQrDetails?.qrcCode : createQRCData?.qrc_UID}
                                      </div>
                                    </div>
                                    <div
                                      className="sub_second_cont1"
                                      style={{
                                        width: "70%",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div className="inputsecond">

                                        <select className="inputfield" style={{ width: "100%" }} name="gadgetCategory" value={qrcData.gadgetCategory} onChange={handleQrcDataChange}>
                                          <option>{t('gadget_category')}</option>
                                          {
                                            gadgetData?.map(i =>
                                              <option value={i}>{i}</option>
                                            )
                                          }
                                        </select>
                                      </div>
                                      <div className="inputsecond">
                                        <input
                                          style={{ width: "100%" }}
                                          className="inputfield"
                                          placeholder={t('name_of_attached_object')}
                                          name="itemName"
                                          value={qrcData.itemName}
                                          onChange={handleQrcDataChange}
                                        />
                                      </div>

                                    </div>
                                  </div>


                                </div>
                              </div>

                              <div className="inputsecond">
                                <textarea
                                  className="inputfield" style={{width:"100%"}}
                                  placeholder={t('enter_description')}
                                  name="itemDescription"
                                  value={qrcData.itemDescription}
                                  onChange={handleQrcDataChange}
                                />
                              </div>
                              <div
  className="inputsecond"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    marginBottom: "10px",
    marginInline: "auto",
    fontSize: "16px",
    border: "2px solid #ccc",
    borderRadius: "8px", 
    padding: "10px", 
    backgroundColor: "#f9f9f9", 
    cursor: "pointer",
  }}
>
  <label
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    {isLoading ? (
      <CircularProgress
        style={{
          width: "20px",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: "auto"
        }}
      />
    ) : (
      <>
        <span>{t('upload_files')}</span>
        <input
          type="file"
          accept="image/*,.pdf"
          // accept="image/*,video/*,.pdf"
          style={{
            display: "none",
          }}
          multiple
          onChange={handleFileInputChangeEdit}
        />
      </>
    )}
  </label>
</div>
<ExampleComponent fileData={allUploadedFiles} setAllUploadedFiles={setAllUploadedFiles}/>

                       
                              <div style={{ display: "flex", width: "100%" }}>
                                <button
                                  type="submit"
                                  className="btn btn-primary d-block mx-auto"
                                  style={{ width: "100%" }}
                                  onClick={toPageSecond}
                                >
                                  {t('preview')}
                                </button>
                              </div>
                            </div>
                          )}
                          {secondPage && (
                            <div>
                              <div
                                style={{
                                  marginTop: "-10px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <IoIosArrowRoundBack
                                  size={28}
                                  onClick={backFirst}
                                  style={{ display: "flex" }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "14px",
                                  }}
                                >
                                  2/3
                                </div>
                              </div>
                              <div className="second_cont">
                                <div
                                  className="sub_second_cont1"
                                  style={{
                                    position: "relative",
                                    flexDirection: "column",
                                    width: "30%",
                                  }}
                                >
                                  <div
                                    className="menu_icon"
                                    onClick={toggleMenu}
                                  >
                                    <BiDotsVerticalRounded size={24} />
                                  </div>
                                  {showMenu && (
                                    <div className="menu">
                                      <button onClick={downloadQR}>
                                        {t('download')}
                                      </button>
                                    </div>
                                  )}
                                  <img
                                    style={{ display: "flex" }}
                                    src={existQrDetails?.qrcCodeUrl ? existQrDetails?.qrcCodeUrl : createQRCData?.qrCodeUrl}
                                    className="image_second"
                                  />
                                  <div
                                        style={{
                                          display: "flex",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {qrcData.itemName ? qrcData.itemName : ""}
                                      </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {existQrDetails?.qrcCode ? existQrDetails?.qrcCode : createQRCData?.qrc_UID}
                                  </div>
                                </div>
                                <div
                                  className="sub_second_cont1"
                                  style={{
                                    width: "70%",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="inputsecond">
                                    <select className="inputfield" style={{ width: "100%" }} name="gadgetCategory" value={qrcData.gadgetCategory} onChange={handleQrcDataChange} defaultValue={qrcData.gadgetCategory} >
                                      <option>{t('gadget_category')}</option>
                                      {
                                        gadgetData?.map(i =>
                                          <option value={i}>{i}</option>
                                        )
                                      }
                                    </select>
                                  </div>
                                  <div className="inputsecond">

                                    <input
                                      style={{ width: '100%' }}
                                      className="inputfield"
                                      placeholder={t('name_of_attached_object_only')}
                                      name="itemName"
                                      value={qrcData.itemName}
                                      onChange={handleQrcDataChange}
                                      defaultValue={qrcData.itemName}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="inputsecond">
                                <textarea
                                  className="inputfield" style={{width:"100%"}}
                                  placeholder={t('description')}
                                  name="itemDescription"
                                  value={qrcData.itemDescription}
                                  onChange={handleQrcDataChange}
                                  defaultValue={qrcData.itemDescription}
                                />
                              </div>
      
                              <div >
                                <div style={{ width: "100%", marginInline: "auto", fontSize: "16px" }} >
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={include}
                                      style={{ marginRight: "10px" }}
                                      onChange={handleIncludeCheckboxChange}
                                    />
                                    {t('include_information')}
                                  </label>
                                  {include && (<>
                                    <div
                                      style={{
                                        marginLeft: "20px",
                                        fontSize: "14px",
                                        display: "flex", flexDirection:"column"
                                      }}
                                    >
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={diridoProfile}
                                          style={{ marginRight: "5px" }}
                                          onChange={(e) => handleCheckboxChangee(e, 'profile')}
                                        />
                                        {projectName} {t('profile')}
                                      </label>
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={showContact}
                                          style={{ marginRight: "5px" }}
                                          onChange={(e) => handleCheckboxChangee(e, 'contact')}
                                        />
                                        {t('contact_information')}
                                      </label>
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={webpageLink}
                                          style={{ marginRight: "5px" }}
                                          onChange={() =>
                                            setWebpageLink(!webpageLink)
                                          }
                                        />
                                        {t('webpage_link')}
                                      </label>
                                    </div>
                                    <div>{webpageLink && (
                                      <div
                                        style={{ marginLeft: "10px" }}
                                      >
                                        <input
                                          type="text"
                                          className="inputfield"
                                          style={{ fontSize: "14px", width: "100%" }}
                                          placeholder={t('enter_link')}
                                          value={webPageLinkField}
                                          onChange={(e) => setWebPageLinkField(e.target.value)}
                                        />
                                      </div>

                                    )}</div></>
                                  )}
                                </div>
                              </div>

                              <div >
                                <div style={{ width: "90%", marginInline: "auto", fontSize: "16px", marginBlock: "20px" }} >
                                
                                <div style={{ display: "flex", width: "100%", justifyContent:"right" }}>
                                <button
                                  type="submit"
                                  className="btn btn-primary d-block ml-auto"
                                  style={{ width: "120px", marginBottom:"15px", whiteSpace:"nowrap" }}
                                  onClick={backFirst}
                                >
                                  {t('add_edit_files')}
                                </button>
                              </div>
                                  <FileViewer fileData={allUploadedFiles}/>
                              
                                </div>
                              </div>


                              <div style={{ display: "flex", width: "100%" }}>
                                <button
                                  type="submit"
                                  className="btn btn-primary d-block mx-auto"
                                  style={{ width: "90%" }}
                                  // onClick={toPageThird}
                                  onClick={handleAddDevice}
                                >
                                  {t('continue')}
                                </button>
                              </div>
                            </div>
                          )}

                          {thirdPage && (
                            <div>
                              <div
                                style={{
                                  marginTop: "-10px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <IoIosArrowRoundBack size={28} onClick={backSecond} style={{ display: "flex" }} />
                                <div style={{ display: "flex", fontSize: "14px" }}>3/3</div>
                              </div>
                              <div className="second_cont">
                                <div
                                  className="sub_second_cont1"
                                  style={{ position: "relative", flexDirection: "column", width: "30%" }}
                                >
                                  <div className="menu_icon" onClick={toggleMenu}>
                                    <BiDotsVerticalRounded size={24} />
                                  </div>
                                  {showMenu && (
                                    <div className="menu">
                                      <button onClick={downloadQR}>{t('download')}</button>
                                    </div>
                                  )}
                                  <img
                                    style={{ display: "flex" }}
                                    src={existQrDetails?.qrcCodeUrl ? existQrDetails?.qrcCodeUrl : createQRCData?.qrCodeUrl}
                                    className="image_second"
                                    alt="QR" />
                                  <div style={{ display: "flex", fontSize: "12px" }}>
                                    {existQrDetails?.qrcCode ? existQrDetails?.qrcCode : createQRCData?.qrc_UID}
                                  </div>
                                </div>
                                <div className="sub_second_cont1" style={{ width: "70%", flexDirection: "column" }}>
                                  <div className="inputsecond">
                                    <input
                                      className="inputfieldthird"
                                      placeholder={t('name_of_attached_object')}
                                      defaultValue={qrcData?.itemName}
                                      value={qrcData?.itemName}
                                      disabled
                                      style={{ textAlign: "center" }}
                                    />
                                  </div>
                                 
                                </div>
                              </div>
                             
                              <div style={{ display: "flex", width: "100%" }}>
                                <button
                                  type="submit"
                                  className="btn btn-primary d-block mx-auto"
                                  style={{ width: "100%" }}
                                  onClick={toPageList}
                                >
                                  {t('done')}
                                </button>
                              </div>
                            </div>
                          )}
                          {qrcList && (
                            <div>
                              <div>
                                {
                                  allQRCData?.length > 0 ?
                                allQRCData?.map((item) => (
                                  // allQRCData?.filter(item => item.userDeviceId !== null).map((item) => (
                                  <div className="list" key={item.qrc_UID} style={{ marginBottom:"10px"}}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                      <p className="list_sub" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", margin: 0 }}>
                                        <span style={{}}>{item?.qrc_UID}{item?.userDeviceId?.itemName && (<> - <span style={{ fontWeight: "300" }}>{item?.userDeviceId?.itemName}</span> </>)} </span>
                                        <div style={{ display:"flex"}}>
                                          {/* {mark ? ( */}
                                      {item?.userDeviceId?.isLost ? (
                                        <p className="list_sub1" style={{justifyContent:"right"}}>
                                          <MdOutlineFileDownload size={22} style={{marginRight:"9px", cursor:"pointer"}} 
                                            onClick={() => {
                                              if (user?.isEnrolledInLostAndFound && user?.isLostAndFoundPlanPaid) {
                                                handleDownloadQRCPaid(item);
                                              } else {
                                                handleDownloadQRCFree(item);
                                              }
                                            }}/>
                                          <MdOutlineModeEdit size={22} style={{ marginRight: "9px", cursor:"pointer" }} onClick={()=>handleEdit(item?.qrc_UID)} />
                                          <ImSad2 size={22} style={{ color: "red" }} />
                                          {/* <AiOutlineInfoCircle size={28} onClick={() => handleTableLogs(item?.qrc_UID)} style={{ cursor: "pointer" }} /> */}
                                        </p>
                                      ) : (
                                        <p className="list_sub1" style={{justifyContent:"right"}} >
                                          <MdOutlineFileDownload size={22} style={{marginRight:"9px", cursor:"pointer"}} 
                                          onClick={() => {
                                            if (user?.isEnrolledInLostAndFound && user?.isLostAndFoundPlanPaid) {
                                              handleDownloadQRCPaid(item);
                                            } else {
                                              handleDownloadQRCFree(item);
                                            }
                                          }}/>
                                          <MdOutlineModeEdit size={22} style={{ marginRight: "10px", cursor:"pointer" }}  onClick={()=>handleEdit(item?.qrc_UID)} />
                                          <ImSad size={22} style={{ cursor: "pointer" }} title="Mark as lost" onClick={() => handleToggleForm(item)}/>
                                        </p>
                                      )}
                                        </div>
                                      </p>
                                     
                                    </div> 
                                    {openTables[item.qrc_UID] && (
                                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                          <tr style={{ background: "rgb(0,95,134)", color: "white", fontWeight: "600", fontSize: "16px" }}>
                                            <th style={{ border: "2px solid white", padding: "8px" }}>{t('scan_period')}</th>
                                            <th style={{ border: "2px solid white", padding: "8px" }}>22/07/2024 - 9:30</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>{t('location')}</td>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>Delhi - India</td>
                                          </tr>
                                          <tr>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>{t('escrow_reward')}</td>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>No</td>
                                          </tr>
                                          <tr>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>{t('marked_as_not_track')}</td>
                                            <td style={{ fontSize: "16px", border: "2px solid white", padding: "8px", background: "rgb(201,209,216)" }}>Yes</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    )}
      {openForms[item.qrc_UID] && (<>
<h5 style={{ marginTop: "5px" }}>{t('edit_device_info')}</h5>
  <Box component="form" style={{ marginTop: "0px" }}>
    <Grid container spacing={2} mb={2}>

                                      
 <Grid item xs={12}>

    <select className="inputfield" style={{ width: "100%" }} name="gadgetCategory" value={qrcData.gadgetCategory} onChange={handleQrcDataChange}>
                                          <option> {t('gadget_category')}</option>
                                          {
                                            gadgetData?.map(i =>
                                              <option value={i} key={i}>{i}</option>
                                            )
                                          }
                                        </select>
                                        </Grid>
      <Grid item xs={12}>
        <TextField
          label={t('item_name')}
          name="itemName"
          variant="outlined"
          fullWidth
          required
          // multiline
          // rows={4}
          value={qrcData.itemName}
          onChange={handleQrcDataChange}/>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label={t('item_description')}
          name="itemDescription"
          variant="outlined"
          fullWidth
          required
          multiline
          rows={4}
          value={qrcData.itemDescription}
          onChange={handleQrcDataChange}
         />
      </Grid>

      <div style={{ width: "90%", marginInline: "auto", fontSize: "16px" }} >
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={include}
                                      style={{ marginRight: "10px" }}
                                      onChange={handleIncludeCheckboxChange}
                                    />
                                    {t('include_information')}
                                  </label>
                                  {include && (<>
                                    <div
                                      style={{
                                        marginLeft: "20px",
                                        fontSize: "14px",
                                        display: "flex"
                                      }}
                                    >
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={diridoProfile}
                                          style={{ marginRight: "5px" }}
                                          onChange={(e) => handleCheckboxChangee(e, 'profile')}
                                        />
                                        {projectName} {t('profile')}
                                      </label>
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={showContact}
                                          style={{ marginRight: "5px" }}
                                          onChange={(e) => handleCheckboxChangee(e, 'contact')}
                                        />
                                        {t('contact_information')}
                                      </label>
                                      <label style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                                        <input
                                          type="checkbox"
                                          checked={webpageLink}
                                          style={{ marginRight: "5px" }}
                                          onChange={() =>
                                            setWebpageLink(!webpageLink)
                                          }
                                        />
                                       {t('webpage_link')}

                                      </label>
                                    </div>
                                    <div>{webpageLink && (
                                      <div
                                        style={{ marginLeft: "10px" }}
                                      >
                                        <input
                                          type="text"
                                          className="inputfield"
                                          style={{ fontSize: "14px", width: "100%" }}
                                          placeholder={t('enter_link')}
                                          value={webPageLinkField}
                                          onChange={(e) => setWebPageLinkField(e.target.value)}
                                        />
                                      </div>

                                    )}</div></>
                                  )}
                                </div>
                                <div
  className="inputsecond"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "90%",
    marginBottom: "10px",
    marginInline: "auto",
    fontSize: "16px",
    border: "2px solid #ccc",
    borderRadius: "8px", 
    padding: "10px", 
    backgroundColor: "#f9f9f9", 
    cursor: "pointer",
  }}
>
  <label
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    {isLoading ? (
      <CircularProgress
        style={{
          width: "20px",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: "auto"
        }}
      />
    ) : (
      <>
        <span>{t('upload_files')}</span>
        <input
          type="file"
          accept="image/*,.pdf"
          // accept="image/*,video/*,.pdf"
          style={{
            display: "none",
          }}
          multiple
          onChange={handleFileInputChangeEdit}
        />
      </>
    )}
  </label>
</div>

                                <div style={{ width: "90%", marginInline: "auto", fontSize: "16px", marginBlock: "20px" }} >
                                <ExampleComponent fileData={allUploadedFiles} setAllUploadedFiles={setAllUploadedFiles}/>

                                 
                                  <Grid container item xs={12} mt={2} justifyContent="center" alignItems="center">
            <Grid item>
                <Button
                    onClick={(e) => {
                      if (!qrcData.deviceCode){
                        handleEditDevicePost(e);
                      } else {
                        handleEditDevice(e);
                      }
                    }}
                    fullWidth
                    style={{ maxWidth: '200px' }} // Optional: limits button width
                >
                    {t('save')}
                </Button>
            </Grid>
            <Grid item>
                <Button
                    onClick={clearData}
                    fullWidth
                    style={{ marginLeft: '20px', maxWidth: '200px' }} 
                >
                    {t('cancel')}
                </Button>
            </Grid>
        </Grid>
                                </div>
    </Grid>
  </Box>
  </>
)}
                                    {/* {isFormVisible[item.qrc_UID] && ( */}
                                    {isFormVisible === item.qrc_UID && (
                                      <div style={{ marginTop: "10px", marginBottom:"15px", borderBottom:"1px solid #d3d3d3" }}>

                                      {lost1 && (
                                        <div>
                                          <h2>{t('mark_as_lost')} : </h2>
                                          <div className="inputsecondThird">
                                            <input
                                              type="text"
                                              name="lostLocationDescription"
                                              className="inputfieldlist"
                                              placeholder={t('location_text_or_geo_url')}
                                              value={formData.lostLocationDescription}
                                              onChange={handleChange}
                                            />
                                            <textarea
                                                        name="note"
                                                        className="inputfieldlist"
                                                        placeholder={t('note_to_finder')}
                                                        value={formData.note}
                                                        onChange={handleChange}
                                              
                                            />
                                          </div>
                                          <div>
                                          <div style={{ display: "flex", flexDirection: "column" }}>
                                          <label style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
    {t('private')}
    <Switch
      checked={formData.isPublic}
      onChange={handleChange}
      name="isPublic"
      color="primary"
    />
    {t('public')}
  </label>

      {formData.isPublic && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginLeft: "5px", fontSize: "14px" }}>
            <input
              type="checkbox"
              name="includeDiridoProfile"
              checked={formData.includeDiridoProfile}
              onChange={handleChange}
            /> {t('include')} {projectName} {t('profile')}
          </label>
          <label style={{ marginLeft: "5px", fontSize: "14px" }}>
            <input
              type="checkbox"
              name="typeContactInfo"
              checked={formData.typeContactInfo}
              onChange={handleChange}
            /> {t('type_contact_details')}
          </label>
          {/* <label style={{ marginLeft: "5px", fontSize: "14px" }}>
            <input
              type="checkbox"
              name="communicateWithFeedbackForm"
              checked={formData.communicateWithFeedbackForm}
              onChange={handleChange}
            /> {t('communicate_via_feedback_form')}
          </label>*/}
        </div> 
      )}
    </div>
                                       </div>
                                          <button
                                            className="btn btn-primary d-block mx-auto"
                                            style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                                            onClick={handleLost2}
                                          >
                                            {t('next')}
                                          </button>
                                        </div>
                                      )}
                                      {lost2 && (
                                        <div>
            <p style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{__html: allData.content}}></p>
            {/* <p style={{ fontSize: "14px" }}>By accepting the terms, you discharge Dirido and its associates and affiliates from any liability arising from the process usage or from the finder of your lost item, or the status of the item.</p> */}
                                          <div>

                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                              <label style={{ marginLeft: "5px", fontSize: "14px" }}>
                                                <input
                                                  type="checkbox"
                                                  name="termsAccepted"
                  checked={checkboxes.termsAccepted}
                  onChange={handleCheckboxChangeLost2}
                                                />{t('accept_terms')}

                                              </label>
                                             
                                            </div>

                                          </div>
                                          <button
                                            className="btn btn-primary d-block mx-auto"
                                            style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                                            onClick={handleLost3}
                                          >
                                            {t('next')}
                                          </button>
                                        </div>
                                      )}
                                      {lost3 && (
                                        <div>

                                          <div>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              <h4 style={{ marginRight: "10px", whiteSpace: "nowrap" }}>{t('reward_amount')} (in {selectedCurrency} - {currencySymbol})</h4>
                                              <input
                                                className="inputfieldlistprice"
                                                style={{ fontSize: "14px", padding: "5px", width: "100%" }}
                                                type="number"
                                                name="rewardAmount"
                                                placeholder={t('reward_amount')}
                                                value={formData.rewardAmount}
                                                onChange={handleChange}
                                              />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
                                            
                                              <label style={{ marginLeft: "5px", fontSize: "14px" }}>
                                                <input
                                                  type="checkbox"
                                                  name="paidByEscrow"
                                                  checked={formData.paidByEscrow}
                                                  onChange={handleChange}
                                                />{" "}
                                                {t('pay_by_escrow')}
                                                <br/>
                                               {t('escrow_fees_info')}
                                              </label>
                                              <label style={{ marginLeft: "5px", fontSize: "14px" }}>
                                                <input
                                                  type="checkbox"
                                                  name="paidByUser"
                                                  checked={formData.paidByUser}
                                                  onChange={handleChange}
                                                />{" "}
                                                {t('pay_directly_to_finder')}
                                                <br />{t('reduce_chances_recover_item')}
                                              </label>
                                            </div>

                                          </div>

                                          <button
                                            className="btn btn-primary d-block mx-auto"
                                            style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                                            onClick={handleSubmitLost}
                                          >
                                            {t('set_as_lost')}
                                          </button>
                                        </div>
                                      )}

                                    </div>
                                    )}
                                  </div>
                                ))
                              :<>
                              {t('no_devices_linked')}</>
                              }
                              </div>
                            </div>
                          )}
                          {track && (
                            <div>
                              <div>
<div>
              {allQRCData && allQRCData.filter(item => item?.userDeviceId?.isLost).length > 0 ? (
  allQRCData?.map((item, index) =>
    item?.userDeviceId?.isLost && (<>
      {/* <div className="list" key={index}>
        <div style={{ display: "flex" }}>
          <p className="list_sub">{item.qrc_UID} - {item?.userDeviceId?.itemName}</p>
          <p className="list_sub1" style={{ width: "100px",alignItems:"center", display:"flex" }}>
          <ImSad2 size={28} style={{ marginRight: "4px", color: "red", cursor: "pointer" }} />
               <HiOutlineEmojiHappy size={32} style={{ marginRight: "4px", cursor: "pointer" }} onClick={() =>
                item?.userDeviceId?.lostEventId?.paidByEscrow
                  ? handleShow1(item)
                  : handleShow(item)
              } title="Mark as found"/>
            <AiOutlineInfoCircle size={30} onClick={() => handleLogTable(index, item.qrc_UID)} style={{ cursor: "pointer",marginRight: "4px", }}/>
            <FaDownload size={28}  style={{ cursor: "pointer" }} title="Download QR Code" 
            onClick={() => {
              if (user?.isEnrolledInLostAndFound && user?.isLostAndFoundPlanPaid) {
                handleDownloadQRCPaid(item);
              } else {
                handleDownloadQRCFree(item);
              }
            }}/>
  <canvas ref={canvasRef} style={{ display: "none" }} />

             </p>
        </div>
        
        {activeIndex === index && (
          <div style={{boxSizing:"border-box", overflowX:"auto"}}>
            {scanLogs[item.qrc_UID] && scanLogs[item.qrc_UID].length > 0 ? (
              <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "10px",
                    overflowX:"auto"
                  }}
              >
                <thead>
                  <tr
                    style={{
                      background: "rgb(0,95,134)",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "16px"
                    }}
                  >
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('scan_time')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('location')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('client_ip')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('client_os')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('coordinates')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('scanned_searched')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {scanLogs[item.qrc_UID].map((log) => (
                    <tr key={log._id}>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {new Date(log.createdAt).toLocaleString()}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                         {log.country}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log.clientIp}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log.clientOs}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                         <a
            href={`https://www.google.com/maps?q=${log.lat},${log.lon}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
          >
            {log.lat}, {log.lon}
          </a>
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log?.isSearched ? "Searched" : "Scanned"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ padding: "10px", color: "#333" }}>
                {t('no_scan_logs')}
              </p>
            )}
          </div>
        )}
      </div> */}
         <div
  key={index}
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    margin: "8px 0",
    border: "2px solid #d3d3d3",
    borderRadius: "8px",
    background: "#fff",
    transition: "all 0.3s ease",
    cursor: "pointer",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#f7f7f7";
    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#fff";
    e.currentTarget.style.boxShadow = "none";
  }}
>
  {/* Left Side Text */}
  <p
    style={{
      margin: 0,
      fontSize: "16px",
      fontWeight: 600,
      color: "#333",
      flex: 1,
      paddingRight: "10px",
      wordBreak: "break-word",
    }}
  >
    {item.qrc_UID} - {item?.userDeviceId?.itemName}
  </p>

  {/* Right Side Icons */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      minWidth: "140px",
      justifyContent: "flex-end",
    }}
  >
    <ImSad2
      size={20}
      style={{ color: "red", cursor: "pointer" }}
    />

    <HiOutlineEmojiHappy
      size={22}
      style={{ cursor: "pointer" }}
      onClick={() =>
        item?.userDeviceId?.lostEventId?.paidByEscrow
          ? handleShow1(item)
          : handleShow(item)
      }
      title="Mark as found"
    />

    <AiOutlineInfoCircle
      size={22}
      style={{ cursor: "pointer" }}
      onClick={() => handleLogTable(index, item.qrc_UID)}
      title="View Logs"
    />

    <FaDownload
      size={20}
      style={{ cursor: "pointer" }}
      title="Download QR Code"
      onClick={() => {
        if (
          user?.isEnrolledInLostAndFound &&
          user?.isLostAndFoundPlanPaid
        ) {
          handleDownloadQRCPaid(item);
        } else {
          handleDownloadQRCFree(item);
        }
      }}
    />

    <canvas ref={canvasRef} style={{ display: "none" }} />
  </div>
  
</div>
  {activeIndex === index && (
          <div style={{boxSizing:"border-box", overflowX:"auto"}}>
            {scanLogs[item.qrc_UID] && scanLogs[item.qrc_UID].length > 0 ? (
              <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "10px",
                    overflowX:"auto"
                  }}
              >
                <thead>
                  <tr
                    style={{
                      background: "rgb(0,95,134)",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "16px"
                    }}
                  >
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('scan_time')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('location')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('client_ip')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('client_os')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('coordinates')}
                    </th>
                    <th style={{ border: "2px solid white", padding: "8px" }}>
                      {t('scanned_searched')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {scanLogs[item.qrc_UID].map((log) => (
                    <tr key={log._id}>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {new Date(log.createdAt).toLocaleString()}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                         {log.country}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log.clientIp}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log.clientOs}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                         <a
            href={`https://www.google.com/maps?q=${log.lat},${log.lon}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
          >
            {log.lat}, {log.lon}
          </a>
                        {/* {log.lat}, {log.lon} */}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          border: "2px solid white",
                          padding: "8px",
                          background: "rgb(201,209,216)"
                        }}
                      >
                        {log?.isSearched ? "Searched" : "Scanned"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ padding: "10px", color: "#333" }}>
                {t('no_scan_logs')}
              </p>
            )}
          </div>
        )}</>
    )
  )
) : (
  <p style={{ padding: "10px", color: "#333" }}>
{t('no_active_qrc_data')}
  </p>
)}

             </div>
                              </div>
                            </div>
                          )}
                {/* <div style={{  paddingtop:"10px"}}>
                    <div style={{display:"flex", justifyContent:"space-evenly"}}>
                    
                    {available?.dynamicQRC?.available >= 0 && (
  <div style={{ display: "flex" }}>
    <strong>Available QRC:</strong> {available?.dynamicQRC?.available}
  </div>
)}

                    {available?.sms?.available >= 0 && (
                <div style={{ display: "flex" }}>
                  <strong>Available SMS:</strong> {available?.sms?.available}
                </div>
              )}

              {available?.whatsapp?.available >= 0 && (
                <div style={{ display: "flex" }}>
                  <strong>Available WhatsApp:</strong> {available?.whatsapp?.available}
                </div>
              )}

      </div>
    </div> */}
     <div style={{ width: "100%", paddingTop: "10px" }}>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-evenly",
      alignItems: "center",
      gap: "10px",
      margin: 0,
      padding: 0,
    }}
  >
    {available?.dynamicQRC?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableQrc")}:</strong>
        <span>{available?.dynamicQRC?.available}</span>
      </div>
    )}

    {available?.sms?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableSms")}:</strong>
        <span>{available?.sms?.available}</span>
      </div>
    )}

    {available?.whatsapp?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableWhatsapp")}:</strong>
        <span>{available?.whatsapp?.available}</span>
      </div>
    )}
  </div>
</div>
                        </div>
                        {/* )} */}
                      </div>
                    </div>
                  </Card.Body>

                </Card>
                <Modal
                  size="md"
                  className="fade text-center d-flex justify-content-center align-items-center modal-width"
                  id="post-modal"
                  onHide={handleClose}
                  show={show}
                  style={{ overflow: "hidden" }}
                >
                  <Modal.Header className="d-flex justify-content-between">
                    <Modal.Title id="post-modalLabel" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                      {t('lost_item_found')}
                    </Modal.Title>
                    <Link to="#" className="lh-1" onClick={handleClose} style={{ textDecoration: 'none', fontSize: '1.5rem' }}>
                      <span className="material-symbols-outlined">close</span>
                    </Link>
                  </Modal.Header>
                  <Modal.Body style={{ maxHeight: "550px", overflowY: "auto", padding: '20px' }}>
                    <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                      {t('congratulations_lost_item')}
                    </p>
                    <Button
                      className="w-100 mt-3"
                        onClick={handleSubmitFound}
                        // onClick={handleConfirm}
                      style={{ backgroundColor: '#007bff', border: 'none', fontSize: '1rem', padding: '10px' }}
                    >
                      {t('confirm')}
                    </Button>
                  </Modal.Body>
                </Modal>
                <Modal size="lg"
                                  className="fade text-center d-flex justify-content-center align-items-center modal-width"
                                  show={show1} onHide={handleClose1} style={{ overflow: 'hidden' }}>
      <Modal.Header className="d-flex justify-content-between">
        <Modal.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
          {t("lost_item_found")}
        </Modal.Title>
        <Button variant="link" onClick={handleClose1} style={{ fontSize: '1.5rem', textDecoration: 'none' }}>
          <span className="material-symbols-outlined">close</span>
        </Button>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '550px', overflowY: 'auto', padding: '20px' }}>
      {showUserList ? (
  <>
    <h4 style={{ marginBottom: '20px' }}>{t("selectUser")}</h4>
    {users?.length > 0 ? (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {users?.map((user) => (
          <div
            key={user.finderId._id}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 15px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div>
              <p style={{ margin: '0', fontWeight: 'bold' }}>{user?.finderId?.fullName}</p>
              <p style={{ margin: '0', fontSize: '0.9rem', color: '#555' }}>{user?.finderId?.email}</p>
              <p style={{ margin: '0', fontSize: '0.9rem', color: '#555' }}>{user?.finderId?.contactNumber}</p>
            </div>
            <button
              onClick={() => setSelectedUser(user)}
              style={{
                padding: '8px 12px',
                backgroundColor: selectedUser?.finderId?._id === user?.finderId?._id ? '#28a745' : '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              disabled={selectedUser?.finderId?._id === user?.finderId?._id}
            >
              {selectedUser?.finderId?._id === user?.finderId?._id ? 'Selected' : 'Select'}
            </button>
          </div>
        ))}
      </div>
    ) : (
      <p style={{ textAlign: 'center', fontSize: '1.2rem', color: '#555', marginTop: '20px' }}>
        {t("noUsersAvailableForSelection")}
      </p>
    )}
    {users?.length > 0 && (
      <button
        className="mt-3"
        onClick={updateFinder}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          display: 'block',
          width: '100%',
        }}
      >
        {t("confirmSelection")}
      </button>
    )}
  </>
) : (
          <>
            <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
              {t("lostItemFoundCongratulations")}
            </p>
            <Button
              className="w-100 mt-3"
              onClick={handleRefund}
              style={{ backgroundColor: '#dc3545', border: 'none', fontSize: '1rem', padding: '10px' }}
            >
              {t("refundAmount")}
            </Button>
            <Button
              className="w-100 mt-3"
              onClick={fetchUsers}
              style={{ backgroundColor: '#28a745', border: 'none', fontSize: '1rem', padding: '10px' }}
            >
              {t("selectUser")}
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
              </Col>
              {/* </InfiniteScroll> */}
            </Col>

            <Col lg={4} >
              <Sponsored />
              <Card className="d-none d-lg-flex">
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">{t('upcoming_events')}</h4>
                  </div>
                </div>
                <Card.Body>
                  <ul className="media-story list-inline m-0 p-0">
                    {upcoming?.length === 0 ? (
                      <li className="d-flex mb-4 align-items-center">
                        <div className="stories-data ms-3">
                          <h5
                            className="mb-1"
                            style={{ fontWeight: "bold", color: "gray" }}
                          >
                            {t('no_upcoming_events')}
                          </h5>
                        </div>
                      </li>
                    ) : (
                      upcoming?.slice(0,4)?.map((data, index) => (
                         <li key={index} className="d-flex mb-4 align-items-center" >
                                                                            <img src={data?.image || s5} alt="story1" className="rounded-circle img-fluid" style={{ width: '50px', height: '50px' }} />
                                                                            <div className="stories-data ms-3">
                                                                                <h5 className="mb-1 hover-blue-event" style={{ fontWeight: 'bold', textTransform: 'capitalize', cursor:"pointer" }} onClick={() => window.open(`https://demo.dirido.com/event/${data?._id}`, '_blank')}>{data?.title}</h5>
                                                                                <p className="mb-0">
                                                                                    {moment(data?.startDate).format('MMMM Do YYYY, h:mm a')}
                                                                                </p>
                                                                                <p className="mb-0">
                                                                                    {t('organized_by')}: {data?.userId?.firstName} {data?.userId?.lastName}
                                                                                </p>
                                                                            </div>
                                                                        </li>
                      ))
                    )}
                  </ul>

                </Card.Body>
              </Card>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
};
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};
export default LostDeviceList;
